import { Cookies as CookiesPage } from '@/containers/cookies/cookies';
import NextApp from '../NextApp';

export default function Cookies() {
  return (
    <NextApp>
      <CookiesPage />
    </NextApp>
  );
}
